import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

interface ICFPreview extends HTMLAttributes<HTMLDivElement> {
    id: string;
    fieldId?: string;
    children: ReactNode;
}

const WhenCFPreview = forwardRef<HTMLDivElement, ICFPreview>((props, ref) => {
    const { id, fieldId, children, ...restProps } = props;

    if (ContentfulLivePreview.initialized) {
        const inspectorProps = useContentfulInspectorMode({ entryId: id });

        return (
            <div ref={ref} {...restProps} {...inspectorProps({ fieldId: fieldId || 'internalName' })}>
                {children}
            </div>
        );
    }

    return children;
});

export default WhenCFPreview;
